import React, { Fragment } from "react";
import PropTypes from "prop-types";
import PSPMarkdownContent from "components/molecules/PSPMarkdown/PSPMarkdownContent";
import CheckmarkGreenIcon from "assets/icons/psp/checkmark-green.svg";
import classNames from "classnames";
import "./StorageUnitSizeChartCard.scss";

export default function StorageUnitSizeChartCard({ storage, background }) {
	return (
		<div className="storage-unit-size-card">
			<div className={classNames("table-contents", background)}>
				<div className="card-header">
					<span className="unit-name">{storage.title}</span>
					{storage.numerics && storage.numerics.length > 0 && (
						<div className="size-badge">
							{storage.numerics.map((numeric, sizeIndex) => (
								<Fragment key={`${storage.title}-${numeric}`}>
									{sizeIndex > 0 && (
										<div className="size-divider" />
									)}
									<span className="size-metric">
										{numeric}
									</span>
								</Fragment>
							))}
						</div>
					)}
				</div>
				{storage.description && (
					<div className="description-content">
						<PSPMarkdownContent
							content={storage.description}
							additionalProps={{
								paragraph: {
									size: "standard",
									color: "black",
									weight: "semiBold",
									style: { padding: 0, margin: 0 }
								}
							}}
						/>
					</div>
				)}
				{storage.bestFor && storage.bestFor.length > 0 && (
					<div className="checkmark-content">
						<span className="best-for-label">Best for:</span>
						{storage.bestFor.map((item) => (
							<div
								key={item}
								className="checkmark-item"
							>
								<div className="checkmark-spacing">
									<img
										src={CheckmarkGreenIcon}
										alt=""
										className="checkmark-icon"
									/>
								</div>

								<div className="checkmark-text"><PSPMarkdownContent
									content={item}
									additionalProps={{
										paragraph: {
											size: "standard",
											color: "black",
											weight: "regular",
											style: { padding: 0, margin: 0, lineHeight: "20px" }
										},
									}}
								/></div>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
}

StorageUnitSizeChartCard.propTypes = {
	storage: PropTypes.shape({
		title: PropTypes.string.isRequired,
		numerics: PropTypes.arrayOf(PropTypes.string),
		bestFor: PropTypes.arrayOf(PropTypes.string),
		description: PropTypes.string
	}).isRequired,
	background: PropTypes.oneOf(["light-blue", "white"])
};

StorageUnitSizeChartCard.defaultProps = {
	background: "light-blue"
};
